import { render, staticRenderFns } from "./ResponderSolicitacao.vue?vue&type=template&id=dfdafb80&"
import script from "./ResponderSolicitacao.vue?vue&type=script&lang=js&"
export * from "./ResponderSolicitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports